import EventUtil from "../Utils/EventUtil";
import Footer from "../Utils/Footer";
import Hero from "../Utils/Hero";
import Navbar from "../Utils/Navbar";
import Offering from "../Utils/Offering";
import Services from "../Utils/Services";

const Events = () => {
  return (
    <div>
      <Navbar />
      <EventUtil />
      <Offering />
      <Footer />
    </div>
  );
};

export default Events;
